<template>
	<div>
		<div class="pc_top">
			<div class="head">
				<div class="search">
					<input name="" type="text" v-model="title" placeholder="请输入关键词搜索" class="search_txt" />
					<input name="" type="submit" value="搜索" class="search_but" @click="go('/newList?level=0&title='+title)"/>
				</div>
				<div class="login"><a href="https://www.qdbxxh.com/admin" target="_blank">用户登录</a></div>
			</div>
			<div class="nav_bg">
				<ul id="nav">
					<li class="mainlevel" style="width:50px"><a href="javascript:void(0)" :class="sel==1?'cur':''"  @click="go('/')">首页</a> </li>
					<li class="mainlevel" v-for="item in configList" @mouseover="enter(item)" @mouseleave="level(item)"><a href="javascript:void(0)" :class="sel==item.categoryCode?'cur':''" @click="go('/newList?level=1&type='+item.categoryCode)">{{item.categoryName}}</a>
						<ul v-if="item.children.length>0&&item.categoryCode==selId" style="display: block;">
							<li v-for="items in item.children"><a href="javascript:void(0)" @click="go('/newList?level=2&type='+items.categoryCode+'&firstCategoryCode='+item.categoryCode)">{{items.categoryName}}</a></li>
						</ul>
					</li>
					<div class="clear"> </div>
				</ul>
			</div>
			<div class="clear"></div>
		</div>

		<!--pc_top-->
		<!--shoujitop-->
		<div class="shouji_top">
			<header :class="['cd-main-header',showPhone?'nav-is-visible':'']"> <a class="cd-logo" href="#0"><img src="../assets/images/logo.png" width="180"
						alt="Logo"></a>
				
				<ul class="cd-header-buttons">
				  <li><a :class="['cd-nav-trigger',showPhone?'nav-is-visible':'']" @click="changePhone"><span></span></a></li>
				</ul>
			</header>
			<nav class="cd-nav">
				<ul id="cd-primary-nav" :class="['cd-primary-nav is-fixed',showPhone?'nav-is-visible':'']"> 
					<li><a href="javascript:void(0)"  @click="go('/')">首页</a></li>
					<li :class="item.children.length>0?'has-children':''" v-for="item in configList"> <a href="javascript:void(0)"  @click="goTwo(item)">{{item.categoryName}}</a>
						<ul class="cd-secondary-nav" v-if="item.children.length>0&&item.categoryCode==selId" style="display: block;">
							<li class="go-back" @click="level(item)"><a href="javascript:void(0)">返回</a></li>
							<li class="see-all"><a href="javascript:void(0)" v-for="items in item.children"  @click="go('/newList?level=2&type='+items.categoryCode+'&firstCategoryCode='+item.categoryCode)">{{items.categoryName}}</a></li>
						</ul>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
	import {
		categorysortPage,articleList
	} from '@/api/reqFetch.js'
	export default {
		components: {},
		props: {

			sel: {
				type: String|Number,
				default: 1
			}

		},
		data() {
			return {
				showPhone: false,
				token: '',
				configList: [],
				title: '',
				selId:''
			}
		},
		computed: {

		},
		mounted() {
			this.getCategorysortPage()
		},
		methods: {
			changePhone() {
				this.showPhone = !this.showPhone
				this.$emit('changePhone', this.showPhone)
			},
			getCategorysortPage() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					this.configList = res.data
				});
			},

			changeTag(item) {
				this.selTag = item
			},
			go(url) {
				if (this.$route.fullPath != url) {
					this.$router.push(url)
					this.$router.go(0)
				}
			},
			enter(item){
				this.selId=item.categoryCode
			},
			level(item){
				this.selId=''
			},
			goTwo(item){
				if(item.children.length>0){
					this.enter(item)
				}else{
					this.go('/newList?level=1&type='+item.categoryCode)
				}
				
			}
		}
	}
</script>